import { LEVELS, isPhoneNative } from '@helpers';

const LEVELS_WITH_SINGLE_VIEW_MODE = [LEVELS.Machines, LEVELS.Persons, LEVELS.ALL];

export const shouldShowModeSelector = (level: string): boolean => {
  const hasMultipleViewModes = LEVELS_WITH_SINGLE_VIEW_MODE.every((l) => !level.includes(l));
  return hasMultipleViewModes || isPhoneNative;
};

export const shouldShowSuggestionsPanel = ({
  isPopupMode,
  suggestionLength,
  isWeb,
  isNarrowWeb,
  isPhone,
}: {
  isPopupMode: boolean;
  suggestionLength: number;
  isWeb: boolean;
  isNarrowWeb: boolean;
  isPhone: boolean;
}): boolean => {
  return (
    isPopupMode &&
    suggestionLength > 0 &&
    ((isWeb && !isNarrowWeb) || (!isWeb && !isPhone))
  );
};
